let isOnline = true;
const listeners = new Set<() => void>();

export function setBridgedOnlineStatus(value: boolean) {
	if (isOnline === value) {
		return;
	}
	isOnline = value;
	for (const listener of listeners) {
		listener();
	}
}

export function getBridgedOnlineStatus() {
	return isOnline;
}

export function subscribeBridgedOnlineStatus(callback: () => void) {
	listeners.add(callback);
	return () => {
		listeners.delete(callback);
	};
}
